import React, { useState } from 'react';
import type { TooltipProps } from '@mui/material/Tooltip';
import MuiTooltip from '@mui/material/Tooltip';

export interface Props extends TooltipProps {
    containerStyle?: React.CSSProperties;
    isControlled?: boolean;
}

const Tooltip: React.FC<Props> = ({ children, containerStyle, isControlled, ...rest }) => {
    const [open, setOpen] = useState(false);

    if (isControlled) {
        return (
            <MuiTooltip
                open={open}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                onClick={() => setOpen(false)}
                {...(rest as TooltipProps)}
            >
                {/* use of div to avoid error :Failed prop type: Invalid prop `children` supplied to `ForwardRef(Tooltip)`, see https://github.com/mbrn/material-table/issues/677 */}
                <div style={containerStyle ?? {}}>{children}</div>
            </MuiTooltip>
        );
    }
    return (
        <MuiTooltip {...(rest as TooltipProps)}>
            {/* use of div to avoid error :Failed prop type: Invalid prop `children` supplied to `ForwardRef(Tooltip)`, see https://github.com/mbrn/material-table/issues/677 */}
            <div style={containerStyle ?? {}}>{children}</div>
        </MuiTooltip>
    );
};

export default Tooltip;
